import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {DexDynWidgetSettings, DexDynWidgetSettingsDef} from './dex-dyn-widget-settings';

@Injectable()
export class DexDynWidgetSettingsService implements WidgetSettingsService {

    public getDefaultSettings(): Observable<DexDynWidgetSettings> {
        const defaultWidgetSettings: DexDynWidgetSettings = {
            title: null
        };

        return of(defaultWidgetSettings);
    }

    public fromDefinition(settingsDef: DexDynWidgetSettingsDef): Observable<DexDynWidgetSettings> {
        return of<DexDynWidgetSettings>({
            title: settingsDef.title
        });
    }

    public toDefinition(settings: DexDynWidgetSettings): DexDynWidgetSettingsDef {
        return {
            title: settings.title
        };
    }

}
